import { JobHistoryPanel } from "@/components/organisms";

export const JobHistory = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <JobHistoryPanel />
    </div>
  );
};
